var runtime = require("../../../../../../build/webpack-environments/loaders/styles/myCssLoader/runtime.js");
module.exports = {"container":"_3-xVx"};
module.exports._getCss = function(wrap, process){return ""+wrap+" ._3-xVx{position:relative;overflow:hidden;touch-action:pan-y pinch-zoom}" };
module.exports._meta = {moduleId: module.id, order: runtime.getOrder()};

